//import Helpers from "../utility/Helpers";
import http from "./HttpService";

export function refreshToken(body) {
  return http.post("Account/RefreshToken", body);
}
export function GetQuestions(body) {
  return http.post("Wheel/GetQuestions");
}
export function SaveAnswers(body) {
return http.post("Wheel/SaveAnswers", body);
}
export function GetSessionData(sessionid) {
  return http.post("Wheel/GetSessionData", {id:sessionid});
  }
  export function GetKeyResults(id) {
    return http.post("Wheel/GetKeyResults", {id:0});
    }
  export function downloadUserSessionsExcelFile() {
      return http.get('Report/DownloadUserSessionsExcelFile', {
        responseType: 'arraybuffer', // Important to handle binary data
            });
   }

export function invalidateToken(token) {
    const body = {
      token: token,
  };
  return http.post("Wheel/InvalidateToken", body);
}
// export function getData(id) {
//   return http.get(`Master/GetData/${id}`);
// }
